import React, { useEffect } from 'react';
import anime from "../utils/anime.es";

const anims = {}

export default function HelloSVG ({isShowing}) {
  const head = React.useRef(null)
  const hand = React.useRef(null)
  
  useEffect(() => {
    anims.wave = anime
    .timeline({
      autoplay: false,
    })
    .add({
      targets: hand.current,
      translateX: '-=15',
      rotate: '-=30',
      duration: 500,
    })
    .add({
      targets: hand.current,
      translateX: 30,
      rotate: 15,
      duration: 750,
    })
    
    anims.flyIn = anime
    .timeline({
      autoplay: false,
    })
    .add({
      targets: head.current,
      translateX: [-25, -10],
      translateY: [60, 10],
      rotate: [0, -15],
      opacity: [0, 1],
      duration: 800,
    })
    .add({
      targets: hand.current,
      translateX: [-15, 10],
      translateY: [60, 0],
      opacity: [0, 1],
      rotate: [0, -15],
      duration: 800,
      complete: () => anims.wave.play()
    }, 0)

  }, [])


  useEffect(() => {
    if(isShowing) {
      if (anims.flyIn.completed && (anims.wave.completed || !anims.wave.began))
        anims.wave.play()    
      if (!anims.flyIn.began)
        anims.flyIn.play()   
    } 
  }, [isShowing])
  
  return (
    <svg viewBox="0 0 300 300" id="hello">
      <defs>
        <style>
          {`
            #hello-head{transform-origin:118px 150px;}
            #hello-hand{transform-origin:196px 170px;}
          `}
        </style>
      </defs>
      <g ref={hand} id="hello-hand">
        <path
          d="M224.93,149.57a4.23,4.23,0,0,0-1.34-4.52c-1.71-1.64-5-2.87-7.15-2a1.6,1.6,0,0,0-.84.74s-.54,1-1.38,2.47c3.37-7.63,3.15-8,2.77-8.62-1.53-2.54-5.4-4.17-8.8-3.7a1.62,1.62,0,0,0-1.25.89c-.08.15-5.28,10.26-10.13,19.07,1.6-5,3.73-11.42,6.29-18.86a1.66,1.66,0,0,0-.26-1.55c-.1-.14-2.62-3.33-8.46-3.35a1.65,1.65,0,0,0-1.57,1.11c-.06.16-5.8,16.3-10.32,27.32a2,2,0,0,0-.27-.44,7.17,7.17,0,0,0-7.22-2,1.7,1.7,0,0,0-.79.5c-.2.23-4.9,5.65-6.81,9.56-1.45,3.09-5.72,14.61.42,32.81,2.3,6.82,10.49,7.35,13.79,7.44a26.26,26.26,0,0,0,13.13,3.39h1.14c3.15,0,5.65,0,7.81-.75,2.5-.84,4.55-2.64,6.66-6.53,3.35-6.16,5.18-13.92,6.51-19.59a37.45,37.45,0,0,1,1.68-6c1.59-2.75,6-10.69,8.65-16.1a1.08,1.08,0,0,0,.08-.19c.6-1.69-1.1-3.64-2.2-4.53a4.62,4.62,0,0,0-2.89-1.17A52.91,52.91,0,0,0,224.93,149.57Zm-3.14-1.1a48.48,48.48,0,0,1-2.44,4.76l-1.87-1a1.11,1.11,0,1,0-1,2l1.84,1c-1.38,2.45-3,5.28-4.63,8.09l-2.87-1.6a1.11,1.11,0,1,0-1.08,1.94l2.83,1.57c-1.11,1.91-2.19,3.75-3.16,5.4a1.66,1.66,0,0,0,2.54,2.08c1.76-1.59,4.16-5.24,6.48-8.78a56.86,56.86,0,0,1,3.91-5.56,4.09,4.09,0,0,1,1.69,1.54l-1.1,2.16-.42-.37a1.11,1.11,0,0,0-1.47,1.66l.83.73c-.71,1.35-1.44,2.72-2.15,4l-1-.79A1.11,1.11,0,1,0,217.3,169l1.3,1.05c-1.23,2.25-2.31,4.17-2.94,5.25a6.91,6.91,0,0,0-.37.81.93.93,0,0,0-.13,0c-6.41-.58-23.73-3.28-26.8-8.69a1.11,1.11,0,0,0-1.93,1.1c4.06,7.11,24.49,9.4,28.18,9.76-.3,1.1-.61,2.42-1,4-1.3,5.48-3.06,13-6.2,18.77-3,5.51-5,5.51-11.56,5.53h-1.15a23,23,0,0,1-11.7-3.1,1.7,1.7,0,0,0-.88-.28c-4.08-.1-9.67-.75-11.17-5.19-5.74-17-1.88-27.53-.58-30.32a52.5,52.5,0,0,1,6-8.4,3.75,3.75,0,0,1,2.75.6c-.09.41-.18.87-.28,1.37-.3,1.55-1,5.33-1.82,6.7a1.07,1.07,0,0,0-.25,0l-4.32,1a1.12,1.12,0,0,0-.82,1.34,1.11,1.11,0,0,0,1.34.81l1.75-.42c-.45,1.49-.74,4-.54,8.16a1.66,1.66,0,0,0,1.26,1.53,1.64,1.64,0,0,0,1.83-.77c4.18-7.07,7.93-18.65,8.28-19.74,3.84-9.36,8.56-22.41,10-26.34a8.15,8.15,0,0,1,4.09,1.45c-1,2.87-1.88,5.48-2.68,7.85l-2.12-.7a1.1,1.1,0,0,0-1.4.7,1.11,1.11,0,0,0,.71,1.4l2.11.7c-1.25,3.72-2.27,6.79-3.08,9.34l-3.42-1a1.11,1.11,0,0,0-.6,2.13l3.35.95c-3.06,9.87-2.47,10.17-1.4,10.7a1.78,1.78,0,0,0,2.34-.79c4.42-6.68,13.87-24.89,16-29.09a6.63,6.63,0,0,1,4.29,1.66c-.47,1.23-1.66,4-3.2,7.42l-3-1.13a1.11,1.11,0,0,0-1.43.65,1.09,1.09,0,0,0,.65,1.42l2.85,1.08c-1.18,2.62-2.5,5.51-3.84,8.42l-3.5-1.74a1.1,1.1,0,1,0-1,2l3.56,1.77c-1.44,3.12-2.86,6.17-4.08,8.79a1.66,1.66,0,0,0,2.77,1.77c4.69-5.54,12.72-19.85,14.57-23.2a5.35,5.35,0,0,1,3.16,1.36C221.53,147.68,221.92,148.12,221.79,148.47Zm-38.58,26a36.06,36.06,0,0,0,6.4,2.13c4.19,1.13,8.95,2.41,13.67,5.69a1.12,1.12,0,0,1,.28,1.55,1.12,1.12,0,0,1-1.54.27c-4.41-3.06-9-4.29-13-5.37a37.89,37.89,0,0,1-6.8-2.28,1.12,1.12,0,0,1-.5-1.49A1.1,1.1,0,0,1,183.21,174.45Zm4.9,7.56c4.64,9.69-2.62,19.77-2.93,20.19a1.11,1.11,0,1,1-1.79-1.31c.07-.09,6.78-9.44,2.73-17.92a1.1,1.1,0,1,1,2-1Z" />
      </g>
      <g ref={head} id="hello-head">
        <path
          d="M181.06,121.47c-12.57.58-18.38-7.16-18.38-7.16,9.67-6.58,10.45-18.38,10.45-18.38s-7.55,8.13-26.12,4.65S128.53,79.86,108.56,80c-26.06.24-29.25,25.37-29.25,25.37-8.12-1.93-17.6,7.16-17.61,16.25A16.29,16.29,0,0,1,54.94,135c5.8,2.13,13.23,0,13.23,0l-2.59,4.06,4.09,4.06L68.29,146l.84,1.48a8.55,8.55,0,0,0-6.06.79c-4.24,2.44-3.4,15,.31,22.19,2.47,4.81,6,7.32,10.17,7.32a11.51,11.51,0,0,0,3.06-.45c1.45,10.65,4.32,23.23,4.49,23.95a1.52,1.52,0,0,0,.57.89c20.24,15.31,44,17.76,57.09,17.76a77.46,77.46,0,0,0,9.93-.54,1.53,1.53,0,0,0,1.25-1.07c5.87-19.17,6.56-50.17,6.4-68,1.43-1.05,2.67-4.5,1.26-5.77a9.28,9.28,0,0,0-1.36-.9c0-1.45-.07-2.71-.1-3.75,10.29,1.63,16.41-.68,16.41-.68l-7.35-5.51C179.7,130.56,181.06,121.47,181.06,121.47Zm-91.8-17.65c2.77-5.09,6.91-8.26,12-9.19,7.09-1.3,15.24,1.82,23.6,9,16.24,14,25.05,12.5,25.14,12.48l.42,2c-.39.08-9.75,1.84-26.91-12.94-7.75-6.68-15.52-9.72-21.88-8.56-4.45.81-8.09,3.63-10.55,8.15-4.43,8.16-2,14,1,18.69l-1.73,1.11C87.25,119.74,84.29,113,89.26,103.82Zm-12,20.51-2-.64c2.51-7.71,8.34-8.71,8.59-8.75l.32,2C84,117,79.32,117.87,77.22,124.33Zm4-13.79c-.16-2.82.11-8.72,4.49-12.6l1.37,1.54c-4.94,4.37-3.68,12.23-3.66,12.31l.33,2L82,112.89a7.16,7.16,0,0,0-7.19,1.31l-1.26-1.63A9.5,9.5,0,0,1,81.21,110.54ZM66.13,169.09c-3.78-7.37-3.11-17.2-1.52-18.12,3.13-1.8,8,.92,9.82,2.26.45,6.55,1.09,11.47,1.41,13.64h0a54.64,54.64,0,0,0,.43,7.39C72,175.63,68.6,173.9,66.13,169.09Zm87-27.05c-3.78-1.86-8.67-3.9-10-4-2-.12-4.19,4.15-2,6.16,1.73,1.57,8.41,4.53,12.09,5.82,0,2.38,0,5,0,7.8-2.16-.87-8.09-2.79-13.25,0l2.45,4.52c3.95-2.15,9.3.41,9.36.44l1.42-2.89c-.18,17.4-1.39,40.81-6,56.55-5.89.61-37.48,2.83-63.3-16.4-.77-3.45-4.88-22.23-5.1-31.64a36.62,36.62,0,0,0,7.78-.36s-1-7.35-1.16-14.7,9.29-10.63,9.29-10.63v-12s9.28-9.67,30-5.2h0c10.89,8.2,20.51,12.1,28.2,13.81C153.06,140.11,153.09,141,153.11,142Z" />
        <path
          d="M126.75,185.26l.12.91a7.78,7.78,0,0,1-3.86-.78c-1.46.19-17.49,4.28-17.78,4.6s-.48,7.22.49,7.59c3,.67,9.57-.66,9.57-.66,9,1.64,11.8-.29,11.8-.29,3.68,1.74,12.86.1,12.86.1s8.81,1,9.1,0a27.55,27.55,0,0,0,0-6.29c-.15-.9-8.52-4-12.27-5.36a15,15,0,0,0,4.75-4.72c.46-.69,1.67-2.52-9.28-41.9l-3,.83c4.78,17.19,9.68,36.66,9.53,39.59C137.71,180.51,134.94,184.2,126.75,185.26Z" />
        <path
          d="M116.11,139.73c-3.19,0-19.08,4.76-21.32,6.5s-.58,8.27,3.63,8.34,19.22-5,21.1-6.46S119.31,139.77,116.11,139.73Z" />
        <path
          d="M117.74,162.87l1.6-4.88c-9.75-3.2-19.4,3.86-19.8,4.16l3.06,4.13C102.68,166.23,110.55,160.52,117.74,162.87Z" />
      </g>
    </svg>
  )
}